// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"ea99e9df","326":"2ee000f1","453":"466fc5e8","604":"0f0c9da3","789":"0b8047b8","822":"3d1cb8b5","864":"35e19c82","905":"ddf8ce1d"}[chunkId] + ".chunk.js";
};